'use client';

import { Grid, InputAdornment, TextField } from '@mui/material';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers-pro/AdapterDayjs';
import { useState } from 'react';

import { Dayjs, dayjs } from '../../utils';
import { EditorModal } from '../modals/editorModal';

interface WaitListStartDateAndPriceModalProps {
	handleClose: () => void;
	handleConfirm: (args: { parkerStartDate: string | null; monthlyFeePrice: string | null }) => void;
	theme: any;
	usesDefaultRates: boolean;
}

export const WaitListStartDateAndPriceModal = ({
	handleClose,
	handleConfirm,
	theme,
	usesDefaultRates,
}: WaitListStartDateAndPriceModalProps) => {
	const [parkerStartDate, setParkerStartDate] = useState<Dayjs | null>(dayjs.utc());
	const [monthlyFeePrice, setMonthlyFeePrice] = useState<string | null>(null);

	return (
		<EditorModal
			handleClose={handleClose}
			handleSave={() =>
				handleConfirm({
					parkerStartDate: parkerStartDate ? parkerStartDate.format('MM/DD/YYYY') : null,
					monthlyFeePrice,
				})
			}
			headerText='Waitlist Parker Info'
			hasUnsavedChanges={false}
			loading={false}
			theme={theme}
			modalWidth='sm'
		>
			<Grid style={{ marginTop: '5px' }} container direction='column' spacing={3}>
				<Grid item xs={12}>
					<LocalizationProvider dateAdapter={AdapterDayjs}>
						<DatePicker<Dayjs>
							label='Parker Start Date'
							value={parkerStartDate}
							minDate={dayjs.utc()}
							onChange={(newValue) => setParkerStartDate(newValue)}
							slotProps={{
								textField: {
									fullWidth: true,
								},
								openPickerIcon: {
									'data-cy': 'date-picker-open-icon',
								},
							}}
						/>
					</LocalizationProvider>
				</Grid>

				{usesDefaultRates && (
					<Grid item xs={12}>
						<TextField
							label='Monthly Fee Price'
							value={monthlyFeePrice ?? ''}
							InputProps={{
								startAdornment: <InputAdornment position='start'>$</InputAdornment>,
							}}
							onChange={(e) => {
								const raw = e.target.value;

								if (raw === '') {
									setMonthlyFeePrice('');
									return;
								}
								if (!/^\d*\.?\d*$/.test(raw)) return;

								const parts = raw.split('.');
								if (parts[1]?.length > 2) return;

								setMonthlyFeePrice(raw);
							}}
							inputProps={{ inputMode: 'decimal' }}
							fullWidth
							data-cy='monthly-fee-price-input'
						/>
					</Grid>
				)}
			</Grid>
		</EditorModal>
	);
};
